













import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListShukasakiSoko',
  components: {
    CtrlSearchCommonComponents,
  },
  props: {
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'sokoCd',
        width: 90,
      },
      {
        text: '倉庫名',
        sortable: true,
        value: 'sokoRyakuMei',
        width: 255,
      },
      {
        text: '工場名',
        sortable: true,
        value: 'shiiresakiRyakuMei',
        width: 340,
      },
    ],
    formatColName: 'sokoCd',
  }),
});
